// The journal of the import runs of a section (platform П14): who loaded what, when and why the rest was skipped.

import type { Id } from '@confdeck/core-shared';

export interface RunReason { row: number; reason: string }

export interface ImportRun {
  id: Id;
  typeId: Id;
  actorId: Id | null;
  fileName: string | null;
  total: number;
  status?: 'done' | 'trial' | 'refused';
  imported: number;
  skipped: number;
  reasons: RunReason[];
  createdAt: string;
}

/** The runs of a section; the journal of another section is not ours. */
export async function fetchImportRuns(typeId: Id): Promise<ImportRun[]> {
  const r = await fetch(`/api/import-runs?typeId=${encodeURIComponent(typeId)}`);
  if (!r.ok) throw new Error(((await r.json()) as { error: { message: string } }).error.message);
  return ((await r.json()) as { items: ImportRun[] }).items;
}
